import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/lesson/importer/lessonImporterActions'

export default importerReducers(actions)
